import { styled } from 'twin.macro';
import { Link } from 'react-router-dom';

const AuthLink = styled(Link)``;

export default AuthLink;
